exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container2d[data-v-1180a08a],.viewer2d[data-v-1180a08a]{height:calc(100vh - 100px);position:relative}", ""]);

// exports
